export default __webpack_public_path__ + "static/media/invoiceView.de52d664.svg";